<template>
  <div v-loading="loading">
    <form @submit.prevent="$marketplace_save">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input
          v-model="model.name"
          type="text"
          class="form-control"
        >
      </div>
      <div class="form-group">
        <label>{{ $t('Title') }}</label>
        <input
          v-model="model.title"
          type="text"
          class="form-control"
        >
      </div>
      <div class="form-group">
        <label>{{ $tc('Domains', 1) }}</label>
        <input
          v-model="model.domain"
          type="text"
          class="form-control"
        >
      </div>
      <div class="form-group">
        <label>{{ $tc('Languages', 1) }}</label>
        <app-language-dropdown v-model="model.language" />
      </div>
      <button
        type="submit"
        class="btn btn-primary"
      >
        {{ $t('Save') }}
      </button>
    </form>
  </div>
</template>

<script>
import MarketplaceMixins from '../mixins/MarketplaceMixins';
import AppLanguageDropdown from '../components/languages/LanguageDropDown.vue';

export default {
  name: 'AppPageMarketplaceMain',
  components: { AppLanguageDropdown },
  mixins: [
    MarketplaceMixins,
  ],
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.$marketplace_load(this.$marketplace_getRouteId());
  },
};
</script>
